import { useMemo } from 'react';
import { useConfig } from 'shared/config/ConfigContext';
import type { HotelResponse } from '@/interfaces';

const DEFAULT_IMAGE = 'https://www.finn.no/assets/finn-logo-large.png';

export const useHotelSeo = (hotel: HotelResponse | null) => {
    const { imgPath, contextPathPP } = useConfig();

    return useMemo(
        () =>
            hotel?.id
                ? {
                      title: `Pakkereiser til ${hotel.name}`,
                      description: [hotel.name, hotel.destination, hotel.region, hotel.country].filter(Boolean).join(', '),
                      url: `https://www.finn.no${contextPathPP}/hotell?hotellId=${hotel.id}`,
                      image: hotel.imagePaths[0] ? `${imgPath}1280w${hotel.imagePaths[0]}` : DEFAULT_IMAGE,
                  }
                : {
                      title: 'Dette hotellet finnes ikke :(',
                      description: 'Vi kunne dessverre ikke finne dette hotellet',
                      url: undefined,
                      image: DEFAULT_IMAGE,
                  },
        [hotel, imgPath, contextPathPP],
    );
};
